







































import { Vue, Component } from "vue-property-decorator"
import { isStringAndHasLength } from "@/utils/validate"
import {
    GET_MARKET_LIST,
    GET_SBLDRIVE_VERSION_LIST,
    GET_COUNTRY_LIST,
} from "@/store/types/getters"
import { fuzzySearchSmartBoxList } from "@/store/types/actions"
import {
    MarketModule,
    VersionModule,
    CountryModule,
    SmartBoxModule,
} from "@/consts"
import { Market, Country, FuzzySearchParameter } from "@/models"

@Component
export default class SCustomerSearchForm extends Vue {
    private marketId: string | null = null
    private sblDriveVersion: string | null = null

    @MarketModule.Getter(GET_MARKET_LIST)
    private marketList!: Market[]

    @VersionModule.Getter(GET_SBLDRIVE_VERSION_LIST)
    private sblDriveVersionList!: string[]

    @CountryModule.Getter(GET_COUNTRY_LIST)
    private countryList!: Country[]

    @SmartBoxModule.Action(fuzzySearchSmartBoxList)
    private fuzzySearchSmartBoxList!: (
        searchParameter: FuzzySearchParameter
    ) => void

    private get customerNameList() {
        return []
    }

    private get hasMarketVersion() {
        return (
            isStringAndHasLength(this.marketId) &&
            isStringAndHasLength(this.sblDriveVersion)
        )
    }

    private onClose() {
        this.$modal.hide("SCustomerSearchForm")
    }

    private onSubmit() {
        if (this.hasMarketVersion) {
            this.fuzzySearchSmartBoxList({
                accurate: {
                    sbldriveversion: this.sblDriveVersion as string,
                    marketid: this.marketId as string,
                },
            })

            this.$router.push(`/customers/${this.marketId}/shops`)
            this.onClose()
        }
    }
}
